
import { cardActionType, CrudCardAction } from '../actions/card.action';
import { Card } from '../models/card.model';
//create a dummy initial state
const initialState: Card []=[]
export function cardReducer(state: Card[] = initialState,action: CrudCardAction) {
  switch (action.type) {
    case cardActionType.MODIFY_CARD:
      state=Object.assign([],state)
      state[action.payload.table]=Object.assign([],state[action.payload.table])
      let stateValueM=state[action.payload.table].status
      let id=null

      if(action.payload.status!="canceled")
      {
        stateValueM=action.payload.status
        id=action.payload.id?
          action.payload.id:null
        if(id==null){
          id=state[action.payload.table].edited_order?state[action.payload.table].edited_order:null
        }
      }


      state[action.payload.table]={
        ...state[action.payload.table],
        edited_order:id,
        status:stateValueM,
        modified:true,
      }

      return {
        ...state
      };
    case cardActionType.SAVE_CARD:

      state=Object.assign([],state)
      state[action.payload.table]=Object.assign([],state[action.payload.table])
      if(state[action.payload.table]==undefined)
      {
        state[action.payload.table]={
          city:null,
          discount:0,
          edited_order:null,
          music_name:[],
          note:null,
          percent_discount:0,
          phone:null,
          prods:[],
          server:0,
          subtotal:0,
          table:null,
          total:0,
          status:"",
          date_accepted:null,
          date_preparing:null,
          modified:false
        };
      }
      let somme=0;
      let idOrder=action.payload.edited_order;

      if(action.payload.edited_order==undefined || action.payload.edited_order==null)
      {
        if(state[action.payload.table].edited_order)
        {
          idOrder=state[action.payload.table].edited_order
        }else{
          idOrder=null
        }
      }
      let state_card:string='';

      if(state[action.payload.table].status!="")
      {
        state_card=state[action.payload.table].status;
      }

      if(action.payload.prod)
      {
        action.payload.prod.map(element=>{
          if(element.price!=element.product.price*element.count && element.price!=0)
            somme=somme+(element.product.price*element.count);
          else{
            somme=somme+element.price;
          }
        })
        state[action.payload.table]={
          ...state[action.payload.table],
          prods:action.payload.prod,
          table:action.payload.table,
          edited_order:idOrder,
          subtotal:somme,
          server:action.payload.server,
          total:somme,
          status:state_card,
          note: action.payload.note !== undefined ? action.payload.note : state[action.payload.table]?.note,
          modified:false
        };



      }else {
        if(action.payload.prods)
        {
          action.payload.prods.map(element=>{
            if(element.price!=element.product.price*element.count && element.price!=0)
              somme=somme+(element.product.price*element.count);
            else{
              somme=somme+element.price;
            }
          })
          state[action.payload.table]={
            ...state[action.payload.table],
            prods:action.payload.prods,
            table:action.payload.table,
            edited_order:idOrder,
            subtotal:somme,
            server:action.payload.server,
            total:somme,
            status:state_card,
            modified:false
          };
        }

      }
    
      return {
        ...state
      };
    case cardActionType.UPLOAD_CARD:

      if(action.payload.res==undefined)
      {
        let dataFromBack=Object.assign([],action.payload)
        state=Object.assign([],state)
        dataFromBack.map(data=>{
          state[data.table]=Object.assign([],state[data.table])
          state[data.table]={
            ...state[data.table],
            prods:data.prods,
            table:data.table,
            edited_order:data.edited_order,
            subtotal:data.subtotal,
            server:data.server,
            total:data.total,
            status:data.status,
            modified:true,
            date_accepted:data.date_accepted,
            date_preparing:data.date_preparing,
            note:data.note||null,
          };
        })
      }
      return {
        ...state
      };

    case cardActionType.STATUS_CARD:

      state=Object.assign([],state)
      state[action.payload.table]=Object.assign([],state[action.payload.table])
      if(state[action.payload.table])
      {
        let stateValue=state[action.payload.table].status

        if(state[action.payload.table].edited_order && (state[action.payload.table].edited_order == action.payload.edited_order ))
        {
          stateValue=action.payload.status
          if(stateValue=='preparing')
          {

            state[action.payload.table]={
              ...state[action.payload.table],
              status:stateValue,
              edited_order:state[action.payload.table].edited_order,
              date_preparing:action.payload.date_preparing,
              note:action.payload.note||state[action.payload.table]?.note||null,
              modified:false,

            }
          }else{
            state[action.payload.table]={
              ...state[action.payload.table],
              status:stateValue,
              edited_order:state[action.payload.table].edited_order,
              note:action.payload.note||state[action.payload.table]?.note||null,
              modified:false,
            }
          }

        }else if(action.payload.res=="canceled" || action.payload.res=="accepted"){
          stateValue=action.payload.status
          let dateAccepted=action.payload.date_accepted?action.payload.date_accepted:null
          state[action.payload.table]={
            ...state[action.payload.table],
            status:stateValue,
            date_accepted:dateAccepted,
            modified:false,

          }

        }else if(action.payload.res=="success" && action.payload.id)
        {
          stateValue=action.payload.status
          state[action.payload.table]={
            ...state[action.payload.table],
            status:stateValue,
            modified:false,

          }
        }

      }

      return {
        ...state
      };

    case cardActionType.RESET_CARD:
    {
      state=Object.assign([],state)
      state[action.payload.table]=Object.assign([],state[action.payload.table])
      state[action.payload.table]={
        city:null,
        discount:0,
        edited_order:null,
        music_name:[],
        note:null,
        percent_discount:0,
        phone:null,
        prods:[],
        server:0,
        subtotal:0,
        table:null,
        total:0,
        status:"",
        date_accepted:null,
        date_preparing:null,
        modified:false
      }

      return {
        ...state
      };
    }
    default:
      return state;
  }
}
